import { useTranslation } from 'react-i18next'
import {
  Wrapper,
  IconWrapper,
  Message,
  Delimiter,
  VerifyNow,
} from '../../NoOfferAlert/AlertCompanyHasNoOffers'
import AttentionIcon from 'components/Common/Icons/Attention'
interface AlertCompanyNotVerifiedProps {
  onVerify: () => void
}
const AlertCompanyNotVerified = ({
  onVerify,
}: AlertCompanyNotVerifiedProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <IconWrapper>
        <AttentionIcon size={16} />
      </IconWrapper>

      <Message>{t('capturedWines.verificationAlert.message')}</Message>
      <Delimiter />
      <VerifyNow onClick={onVerify}>
        {t('capturedWines.verificationAlert.verifyNow')}
      </VerifyNow>
    </Wrapper>
  )
}

export default AlertCompanyNotVerified
